var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLevel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 33,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FB923C",
  d: "M17.137 10.563a1.6 1.6 0 0 0-.529-.336 1.6 1.6 0 0 0-1.216 0c-.196.077-.377.19-.528.337l-4.8 4.8a1.607 1.607 0 0 0 2.272 2.272l2.064-2.08V21.3a1.6 1.6 0 0 0 3.2 0v-5.745l2.064 2.08a1.6 1.6 0 0 0 2.272 0 1.6 1.6 0 0 0 0-2.272zM16 .5a16 16 0 1 0 0 32 16 16 0 0 0 0-32m0 28.8a12.8 12.8 0 1 1 0-25.599 12.8 12.8 0 0 1 0 25.6"
})));
export default SvgLevel;